"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginate = void 0;
const paginate = (array) => ({ page, pageSize } = { pageSize: 20, page: 1 }) => {
    const totalPages = Math.ceil(array.length / pageSize);
    if (page === 'first')
        page = 1;
    if (page === 'last')
        page = totalPages;
    if (page < 1)
        throw new Error('Page must be greater than 0');
    const start = (page - 1) * pageSize;
    const end = page * pageSize;
    const items = array.slice(start, end);
    return {
        items,
        pagination: {
            totalRecord: array.length,
            totalPages,
            pageSize,
            page
        }
    };
};
exports.paginate = paginate;
